import React from "react";

const DebugConsole = () => (
  <div>
    <h4>Debug Console</h4>
    <p>Debug logs appear here.</p>
  </div>
);

export default DebugConsole;
